import { render, staticRenderFns } from "./fl44-new-proposal-button.vue?vue&type=template&id=afd63590&"
import script from "./fl44-new-proposal-button.vue?vue&type=script&lang=js&"
export * from "./fl44-new-proposal-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afd63590')) {
      api.createRecord('afd63590', component.options)
    } else {
      api.reload('afd63590', component.options)
    }
    module.hot.accept("./fl44-new-proposal-button.vue?vue&type=template&id=afd63590&", function () {
      api.rerender('afd63590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl44/partials/fl44-new-proposal-button.vue"
export default component.exports